<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      title="Modify function"
      :visible.sync="addDialogVisible"
      :close-on-click-modal="false"
      :center="true"

      @opened="opened"

      width="500px"
      size="small">

      <el-form
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="Function Key: "  required>
          <el-input v-model="editFunctionPermission.functionKey" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Name: "  required>
          <el-input v-model="editFunctionPermission.functionName" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Decription: " >
          <el-input v-model="editFunctionPermission.description" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Icon: " >
          <el-input v-model="editFunctionPermission.icon" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Url: "  >
          <el-input v-model="editFunctionPermission.url" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Is Menu: " >
          <el-switch
            v-model="editFunctionPermission.functionType"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="MENU"
            inactive-value="FUNCTION">
          </el-switch>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="save">Save</el-button>
              <el-button @click="addDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import util from '@/util/util.js'
  let Base64 = require('js-base64').Base64
  export default {
    components: {

    },
    props:  {
      parentId:{
        type: String,
        required: true,
        default: () => ''
      },
      functionPermissionTreeDTOS: {
        type: Object,
        required: true,
        default:() => {}
      }
   },
    data(){
      return{
        addDialogVisible: false,
        dataLoading: false,
        editFunctionPermission:{},
      }
    },
    computed: {
    },
    created(){
    },


    methods: {
      opened(){
        this.editFunctionPermission = util.deepClone(this.functionPermissionTreeDTOS);
      },
      showDialog(){


        this.addDialogVisible = true;
      },
      hideDialog(){
        this.addDialogVisible = false;
      },
      save(){
        if(!this.editFunctionPermission.functionKey){
          this.$message.warning('Function Key can not be empty ');
          return;
        }
        if(!this.editFunctionPermission.functionName){
          this.$message.warning('Function Name can not be empty  ');
          return;
        }


        let url = this.baseAcsUrl + '/acs/function-permission/update-function';
        this.dataLoading = true;
        this.editFunctionPermission.parentId = this.parentId === '0' ? null : this.parentId;
        this.editFunctionPermission.children = null;
        let newObj = {...this.editFunctionPermission}
        newObj.functionKey = Base64.encode(this.editFunctionPermission.functionKey)
        newObj.functionName = Base64.encode(this.editFunctionPermission.functionName)
        if(this.editFunctionPermission.description){
          newObj.description = Base64.encode(this.editFunctionPermission.description)
        }
        if(this.editFunctionPermission.icon){
          newObj.icon = Base64.encode(this.editFunctionPermission.icon)
        }
        if(this.editFunctionPermission.url){
          newObj.url = Base64.encode(this.editFunctionPermission.url)
        }
        this.http.put(url,newObj).then(resp =>{
          this.$message.success('Successful operation ');
          this.addDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/function_permission/dialog/edit_function.vue